import type { ReactNode } from 'react'

interface DashboardSectionProps {
  title: string
  /** Slot rendered opposite the title (e.g. a "see all" link). */
  action?: ReactNode
  children: ReactNode
}

export function DashboardSection({ title, action, children }: DashboardSectionProps) {
  return (
    <section className="flex flex-col gap-2">
      <div className="flex items-baseline justify-between gap-2">
        <h2 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
          {title}
        </h2>
        {action}
      </div>
      {children}
    </section>
  )
}
